<template>
  <div draggable="false" @mousedown.stop>
     <audio style="height:0px;display:none;" @play="isPlayerPlaying = true;$emit('playerPlayed')" @pause="isPlayerPlaying = false;$emit('playerPaused')" @timeupdate="handleTimeUpdate" ref="audioPlayerRef" @loadedmetadata="handleAudioMetadataloaded"  class="audio-player" controls="controls" controlslist="nodownload">
         <source :src="audioUrl" type="audio/mpeg" />
    </audio>

     
     <div class="custom-audio-player-wrapper" draggable="false" :style="isPlayButtonEnabled()"  style="display: grid;gap: 15px; box-sizing: border-box;">
        <div class="play-pause-button-wrapper" v-if="isPlayButtonRequired">
           <button v-if="isPlayerPlaying" :style="buttonHeight" @click="handlePause()" style="display: flex; align-items: center;justify-content:center;height:33px"  class="btn btn-outline-secondary play">  
                    <svg style="width:18px;height:18px;" xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 0 24 24" width="24px" fill="currentColor"><path d="M0 0h24v24H0V0z" fill="none"/><path d="M6 19h4V5H6v14zm8-14v14h4V5h-4z"/></svg>
           </button>
            <template v-else>
               <button @click="handlePlay()" :style="buttonHeight" style="display: flex; align-items: center;justify-content:center;height:33px"  class="btn btn-outline-secondary play">
                    <svg  style="width:18px;height:18px;"  xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 0 24 24" width="24px" fill="currentColor"><path d="M0 0h24v24H0V0z" fill="none"/><path d="M10 8.64L15.27 12 10 15.36V8.64M8 5v14l11-7L8 5z"/></svg>
               </button>
            </template>
        </div>
        <div class="volume-bar-wrapper">
            <div class="volume-increase-decrease">
                 <svg v-if="currentVolume > 0" @click="handleVolumeMute()" xmlns="http://www.w3.org/2000/svg"  height="24px" viewBox="0 -960 960 960" width="24px" fill="#b6bec7"><path d="M560-131v-82q90-26 145-100t55-168q0-94-55-168T560-749v-82q124 28 202 125.5T840-481q0 127-78 224.5T560-131ZM120-360v-240h160l200-200v640L280-360H120Zm440 40v-322q47 22 73.5 66t26.5 96q0 51-26.5 94.5T560-320ZM400-606l-86 86H200v80h114l86 86v-252ZM300-480Z"/></svg>
                 <svg  v-else @click="handleVolumeUnMute()" xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#b6bec7"><path d="M792-56 671-177q-25 16-53 27.5T560-131v-82q14-5 27.5-10t25.5-12L480-368v208L280-360H120v-240h128L56-792l56-56 736 736-56 56Zm-8-232-58-58q17-31 25.5-65t8.5-70q0-94-55-168T560-749v-82q124 28 202 125.5T840-481q0 53-14.5 102T784-288ZM650-422l-90-90v-130q47 22 73.5 66t26.5 96q0 15-2.5 29.5T650-422ZM480-592 376-696l104-104v208Zm-80 238v-94l-72-72H200v80h114l86 86Zm-36-130Z"/></svg> 
                <div class="volume-vertical-wrapper">
                    <VueRangeSlider tooltip-placement="right"  :tooltip-formatter="val => val+'%'" tooltip="focus" direction="btt" :clickable="false" style="height:100%;" :dot-attrs="getDotsAttr()" @drag-end="handleVolumeDragEnd()"  ref="volumeSlider"  v-model="currentVolume" v-bind="{min:0,max:100,enableCross:true}" :enableCross="false" @change="handleChangeVolume">
                    </VueRangeSlider>
                </div>
            </div>
        </div>
        <div class="progress-bar-wrapper">
            <VueRangeSlider :dotSize="18" tooltip-placement="top" :tooltip-formatter="handleTooltipFormatter" tooltip="focus" :duration="0.1" @drag-end="handleProgressBarDragEnd()" ref="progressSliderRef" :marks="markinMarkout" :clickable="false" :dot-attrs="getDotsAttr()" v-model="value" v-bind="options" :enableCross="false" @change="handleCursorSlide">
            </VueRangeSlider>
        </div>
        <div class="progres-overall-progress" :style="isPlayButtonRequired?'padding-inline-end:6px;':''">
           <div class="player-current-time-division">
                <span class="currrent-time">{{getDuration(currentTime)}}</span> 
                <span class="time-division-label">/</span> 
                <span class="full-time-of-time-division">{{getDuration(duration)}}</span>
            </div>
        </div>
     </div>

  </div>
</template>

<script>
import Utils from '../../components.utils.js';
import VueRangeSlider from 'vue-slider-component';
import 'vue-slider-component/theme/default.css';
export default {
  name:'CustomAudioPlayer',
 // props:['fileInfo','isPlayButton'],
  props:{
     fileInfo:{
        type: Object,
        default(){
            return {};
        }
     },
     subclipDetails:{
        type: Object,
        default(){
            return {};
        }
     },
     isPlayButtonRequired:{
        type: Boolean,
        default(){
            return true;
        }
     },
     isBorderRequired:{
        type: Boolean,
        default(){
            return false;
        }
     },
     buttonHeight:{
        type: String,
        default(){
            return '';
        }
     },
  },
  components:{
    VueRangeSlider
  },
  data(){
     return {
      audioUrl : null,
      options: {
        min:0,
        max:100,
      },
      value:[0],
      currentVolume:100,
      markinMarkout:{},
      MILLI_SECOND: 1000,
      isDragging:false,
      inMarkerValue: null,
      outMarkerValue:null,
      currentTime:0,
      duration:null,
      isActivePreview:false,
      isVolumeMuted:false,
      lastVolume:0,
      isPlayerPlaying:false
     }
  },
  methods:{
    handlePause(){
       this.isPlayerPlaying = false;
       this.$refs.audioPlayerRef.pause();
    },
    handlePlay(){
       this.isPlayerPlaying = true;
       this.$refs.audioPlayerRef.play();
    },
    isPlayButtonEnabled(){
        let border = '';
        if(this.isBorderRequired){
            border = 'border-radius:5px;';
        }
        if(!this.isPlayButtonRequired){
           return `grid-template-columns: 1fr 7fr 2fr;${border}`;
        }else{
           return `grid-template-columns: 1fr 1fr 6fr 2fr;${border}`;
        }
    },
    handleVolumeDragEnd(){
        this.$refs.volumeSlider.blur();
    },
    handleProgressBarDragEnd(){
        this.isDragging = false;
        this.$refs.progressSliderRef.blur();
    },
    getAudioPlayer(){
        return this.$refs.audioPlayerRef;
    },
    handleTooltipFormatter(value){
        return this.getDuration(value/this.MILLI_SECOND);
    },
    handleVolumeMute(){
       this.lastVolume = this.currentVolume;
       this.currentVolume = 0;
       this.$refs.audioPlayerRef.volume = 0;
    },
    handleVolumeUnMute(){
      this.currentVolume = this.lastVolume;
      this.$refs.audioPlayerRef.volume = (this.currentVolume / 100);
    },
    listenAudioBetweenMarkers(){
        console.log(`[listenAudioBetweenMarkers]`);
        if(!this.inMarkerValue){
           alert("No Markin");
           return;
        }
        if(!this.outMarkerValue){
           alert("No Markout");
           return;
        }
        this.$refs.audioPlayerRef.currentTime = this.inMarkerValue / this.MILLI_SECOND;
        this.$refs.audioPlayerRef.play();
    },
    setPreviewState(value){
        this.isActivePreview = value;
    },
    restMarkinMarkoutMarkers(){
        this.markinMarkout = {};
        this.isActivePreview = false;
        this.inMarkerValue = null;
        this.outMarkerValue = null;
    },
    handleChangeVolume(steps){
        let volume = (steps / 100) // volume between 0 -1 
        this.$refs.audioPlayerRef.volume = volume;
        localStorage.setItem('fusion:playerVolume',String(volume));
    },
    getDuration(time){
        return Utils.getDurationInHHorMMSS(time);
    },
    handleCursorSlide(steps,index){
       this.isDragging = true;
       if(index == 0){
            this.$refs.audioPlayerRef.currentTime = steps / this.MILLI_SECOND;
       }
    },
    setMarkinMarker(inValue = null,callback = null){
        if(!inValue){
          inValue = parseInt(this.$refs.audioPlayerRef.currentTime * this.MILLI_SECOND);
        }else{
           inValue = parseInt(inValue);
        }
        this.markinMarkout = {};
        this.markinMarkout[inValue] = '';
        this.inMarkerValue = inValue;
        this.$nextTick(()=>{
             const marker = this.$refs.progressSliderRef.$el.querySelector('.vue-slider-mark:first-child');
             marker.style.setProperty('--width','0px');
             if(callback && typeof callback == 'function'){
                 callback();
             }
        });
    },
    setMarkoutMarker(outValue = null,callback = null){
        if(!outValue){
          outValue = parseInt(this.$refs.audioPlayerRef.currentTime * this.MILLI_SECOND);
        }else{
           outValue = parseInt(outValue);
        }
        this.outMarkerValue = outValue;
        this.markinMarkout = {};
        let data = {};
        data[this.inMarkerValue] = '';
        data[outValue] = '';
        this.markinMarkout = data;
       // this.$set(this.markinMarkout,data);
        let inVal = Number(((Number(Object.keys(this.markinMarkout)[0]) / Number(this.options.max) ) * 100).toFixed(4));
        let outVal = Number(((Number(Object.keys(this.markinMarkout)[1]) / Number(this.options.max) ) * 100).toFixed(4));
        let width = outVal - inVal;
        let sliderWidth = this.$refs.progressSliderRef.$el.offsetWidth;
        let widthInPx = (width / 100) * sliderWidth;
        const marker = this.$refs.progressSliderRef.$el.querySelector('.vue-slider-mark:first-child');
        marker.style.setProperty('--width',widthInPx.toFixed(4)+'px');
        marker.classList.add('show-selected-region');
        this.$nextTick(()=>{
             if(callback && typeof callback == 'function'){
                 callback();
             }
        });
    },
    getDotsAttr(){
        return { 'main-slider-dot': 'main' };
    },
    handleTimeUpdate(){
       // console.log(`[handleTimeUpdate]`,event);
        this.currentTime = this.$refs.audioPlayerRef.currentTime;
        let curTime = this.currentTime * this.MILLI_SECOND;
        if(this.isActivePreview){
            if(curTime >= this.outMarkerValue){
                this.$refs.audioPlayerRef.pause();
                this.isActivePreview = false;
                this.$emit("listen:completed");
            }
        }
        if(this.isDragging) return;
        let progress = parseInt(this.$refs.audioPlayerRef.currentTime * this.MILLI_SECOND);
        if(Array.isArray(this.value)){
            this.$set(this.value,0,progress)
        }else{
            this.value = parseInt(this.$refs.audioPlayerRef.currentTime * this.MILLI_SECOND);
        }
    },
    getAudiowaveform(file){
          return Utils.getAudiowaveformFromFileInfo(file)
    },
    handleAudioMetadataloaded(event){
        this.options.max = parseInt(event.target.duration * this.MILLI_SECOND);
        this.duration = event.target.duration;
        this.$emit('audioDuration',this.duration);
        try{
            if(localStorage.getItem('fusion:playerVolume') != null){
                let v = Number(localStorage.getItem('fusion:playerVolume'));
                if(!isNaN(v)) { 
                    this.currentVolume = v * 100;
                    this.$refs.audioPlayerRef.volume = v;
                }
            }
        }catch(e){console.log(e)}
        if(this.subclipDetails && Object.prototype.hasOwnProperty.call(this.subclipDetails,'markers') && Object.keys(this.subclipDetails.markers).length){
            //show subclip;
            this.setMarkinMarker(this.subclipDetails.markers.start,()=>{
                  this.setMarkoutMarker(this.subclipDetails.markers.end,()=>{
                      this.$refs.audioPlayerRef.currentTime = this.subclipDetails.markers.start / this.MILLI_SECOND;
                      this.isActivePreview = true;
                      this.$refs.audioPlayerRef.play().then(()=>{
                          this.$emit('audioStartedPlaying');
                      });
                  });
            });
        }
    },
    playSubclipArea(subclipDetails){
        console.log("playSubclipArea",subclipDetails);
        if(subclipDetails && subclipDetails.markers && subclipDetails.markers.start){
            let currentTime = subclipDetails.markers.start;
            if(currentTime < 0) currentTime = 0;
            this.$refs.audioPlayerRef.currentTime = currentTime;
        }
        if(subclipDetails && subclipDetails.markers && subclipDetails.markers.end <= subclipDetails.markers.start){
           return;
        }
        this.setMarkinMarker(subclipDetails.markers.start,()=>{
            this.setMarkoutMarker(subclipDetails.markers.end,()=>{
                this.$refs.audioPlayerRef.currentTime = subclipDetails.markers.start / this.MILLI_SECOND;
                this.isActivePreview = true;
                this.$refs.audioPlayerRef.play().then(()=>{
                    this.$emit('audioStartedPlaying');
                });
            });
        });
    },
    playPuseAudio(){
        if(this.$refs.audioPlayerRef){
          if(this.$refs.audioPlayerRef.paused){
              this.$refs.audioPlayerRef.play();
              this.$emit('playerPlayed');
          }else{
             this.$refs.audioPlayerRef.pause();
             this.$emit('playerPaused');
          }
       }
    },
    playVideo(){
       this.$refs.audioPlayerRef.play();
       this.$emit("audioStartedPlaying");
    },
    resetMarkers(){
         this.restMarkinMarkoutMarkers();
         this.outMarkerValue = null;
         this.outMarkerValue = null;
         this.value = [0];
    },
    setCurrentTime(time){
       this.getAudioPlayer().currentTime = time;
    },
  },
  created(){
      this.audioUrl = this.getAudiowaveform(this.fileInfo);
      this.$emit('stopPlaying');
  },
}
</script>

<style lang="scss" scoped>
  $progress-bg-color: #28cfd8;
  $text-color: #eee;
  $dull-text-color: #757575;
  .custom-audio-player-wrapper{
    display: flex;
    width: 100%;
    background: #23282a;
    justify-content: space-between;
    padding: 12px;
    align-items: center;
    box-shadow: 0 4px 10px rgba(34, 34, 34, 0.5);
   // border-radius: 5px;
  }
/*   .progres-overall-progress{
    flex-basis: 16%;
    padding-inline-start: 15px;
  } */
  .progress-bar-wrapper{
     flex-basis: 80%;
  }

  .volume-bar-wrapper{
      position: relative;
  }

  .volume-vertical-wrapper{
     position: absolute;
     width: 10px;
     height: 221px;
     display: flex;
  }

  .volume-vertical-wrapper {
    position: absolute;
    width: 37px;
    height: 109px;
    display: flex;
    z-index: 999;
    inset-inline-start: -3px;
    bottom: 17px;
    justify-content: center;
    align-items: center;
    visibility: hidden;
    padding-bottom: 12px;
 }

 .volume-bar-wrapper:hover .volume-vertical-wrapper{
     visibility: visible;
 }

 .progress-bar-wrapper .vue-slider-process{
    background: $progress-bg-color;
 }

 .player-current-time-division{
        width: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        letter-spacing: 1px;
        font-weight: 400;
        font-size: 12px;
        font-family: Roboto,Arial,sans-serif!important;
        .currrent-time{
            color: $text-color;
           // min-width: 60px;
        }
        .time-division-label{
            margin-inline-start: 5px;
            margin-inline-end: 5px;
            color: $dull-text-color;
        }
        .full-time-of-time-division{
            color: $dull-text-color;
           // min-width: 60px;
        }
    }

 ::v-deep{
     .vue-slider.vue-slider-btt{
        padding: 0 !important;
     }

     .volume-vertical-wrapper .vue-slider-rail{
        border-radius: 0 !important;
        background: #383c3e !important;
     }

     .vue-slider-process{
        background: $progress-bg-color;
     }

   .progress-bar-wrapper .vue-slider-marks .vue-slider-mark{
      height: 17px !important;
      background: #ea4563;
      width: 2px !important;
      //z-index: 6;
   }

   .progress-bar-wrapper .vue-slider-mark:first-child:before {
        content: "";
        position: absolute;
        inset-inline-start:0;
        top: 7px;
        background: #ea4563;
        height: 5px;
        width: var(--width);
    }

    .vue-slider-dot-handle{
       background: #28cfd8 !important;
    }

   .vue-slider-rail{
      background-color: rgba(115, 133, 159, .75);
   }

   .vue-slider-dot-tooltip-inner{
      padding: 4px 11px !important;
      border-color: #2e2c2c;
      background-color: #2e2c2c;
      font-size: 12px;
   }

 }

</style>